import React, { useState, useEffect } from 'react';

import moment from 'moment';

import { Modal, Radio } from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';

import { Autorenew as LoadingIcon, Edit } from '@material-ui/icons';

import { submitAlmaXAssignmentEvaluation } from '../../../services/apiService';
import { RefreshCounterContext } from '../index';

import RenderProfilePic from '../../../extras/RenderProfilePic';

const timeFormat = 'DD MMM YYYY hh:mm:ss a';

export default function AdminFeedbackModal({ params }) {
  const setRefreshCounterFn = React.useContext(RefreshCounterContext);

  const [openModal, setOpenModal] = useState(false);
  const [rating, setRating] = useState([]);
  const [fixedRating, setFixedRating] = useState([]);

  const [plaigarism, setPlaigarism] = useState('');
  const [feedbackText, setFeedbackText] = useState('');

  const [loading, setLoading] = useState(false);

  const [isRatingDecreaseError, setIsRatingDecreaseError] = useState(false);

  useEffect(() => {
    const feedbackObj = params?.data?.coachFeedback;

    const allRubricsArr = params.data?.assignment?.attributes?.rubrics;

    setFeedbackText(feedbackObj?.feedback);

    const rubricsValue = feedbackObj?.ratings;

    if (!allRubricsArr) return;
    for (let i = 0; i < allRubricsArr?.length; i++) {
      const rubricItem = allRubricsArr[i];
      const rubricItemKey = rubricItem.rubricKey;

      if (rubricsValue && rubricsValue[rubricItemKey]) {
        rubricItem.value = rubricsValue[rubricItemKey];
      } else {
        rubricItem.value = 0;
      }
    }

    if (feedbackObj?.plagiarisedSolution) {
      setPlaigarism('plagiarised');
    } else {
      setPlaigarism('self_written');
    }

    setRating(allRubricsArr);
    setFixedRating(JSON.parse(JSON.stringify(allRubricsArr)));
  }, []);

  const onSubmit = async () => {
    const ratingObj = {};

    for (let i = 0; i < rating.length; i++) {
      const item = rating[i];

      if (!item.value) {
        return;
      }

      ratingObj[item.rubricKey] = item.value;
    }

    setLoading(true);

    const body = {
      evaluatorUserId: params?.data?.evaluatorUserId,
      assignmentId: params?.data?.assignmentId,
      submissionId: params?.data?.submissionId,
      coachFeedback: {
        ratings: ratingObj,
        feedback: feedbackText,
        plagiarisedSolution: plaigarism === 'plagiarised',
      },
    };

    try {
      await submitAlmaXAssignmentEvaluation(body);
      setLoading(false);
      setOpenModal(false);
      setRefreshCounterFn((counter) => counter + 1);
    } catch (error) {
      console.error(error);
    }
  };

  const handlePlaigarismCLick = (event) => {
    setPlaigarism(event.target.value);
  };

  const isModal =
    params?.data?.credits !== null && params?.data?.credits !== undefined;

  return (
    <div>
      <div
        className='flex items-center h-full text-blue-600 cursor-pointer'
        onClick={() => {
          setOpenModal(true);
        }}
      >
        {isModal ? params?.data?.credits : ''}
        {isModal ? <Edit className='mx-2' /> : ''}
      </div>

      {isModal && (
        <Modal
          open={openModal}
          aria-labelledby='modal-modal-title'
          aria-describedby='modal-modal-description'
        >
          <div className='relative overflow-y-auto h-5/6 top-2 md:top-10 m-auto bg-white  rounded-lg md:px-8 px-3 py-4 z-50 lg:w-1/2 w-11/12 border-solid border border-gray-600'>
            <div
              className='absolute right-2 top-2 cursor-pointer'
              onClick={() => {
                setOpenModal(false);
              }}
            >
              X
            </div>
            <div className='flex flex-col'>
              <div className='flex mb-4'>
                {params.data?.assignment?.attributes?.icon?.data?.attributes
                  ?.url ? (
                  <img
                    src={
                      params.data?.assignment?.attributes?.icon?.data
                        ?.attributes?.url
                    }
                    className='w-16 h-16 rounded-full'
                  />
                ) : (
                  <RenderProfilePic
                    name={params.data?.assignment?.attributes?.name}
                    thumbnail=''
                    size='3'
                  />
                )}

                <div className='flex-auto'>
                  <div className='mr-2 px-4 flex items-center gap-3'>
                    <div className='flex-auto'>
                      <h3 className='font-medium'>
                        {params.data?.assignment?.attributes?.name}
                      </h3>
                    </div>
                    <div>
                      <div className='text-gray-500 text-sm grow-0'>
                        Submitted on{' '}
                        {moment(params?.data?.submittedAt).format(timeFormat)}
                      </div>
                      {params?.data?.evaluatedAt && (
                        <div className='text-gray-500 text-sm grow-0'>
                          Evaluated on{' '}
                          {moment(params?.data?.evaluatedAt).format(timeFormat)}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='flex items-center px-4 mt-3 rounded w-max text-sm'>
                    <div className='font-medium mr-5'>By</div>
                    <RenderProfilePic
                      thumbnail={params?.data?.Student?.thumbnail}
                      name={params?.data?.Student?.firstName}
                      size={3}
                    />
                    <div className='ml-2'>{`${params.data?.Student?.firstName} ${params.data?.Student?.lastName}`}</div>
                  </div>
                </div>
              </div>
              <hr className='mb-4' />
              <div className='font-bold'>Ratings & Feedback</div>

              {rating.map((rubricItem, index) => (
                <div className='flex mb-2' key={index}>
                  <div className='w-64 text-gray-400 text-sm'>
                    {rubricItem.rubricName} {`(${rubricItem.rubricWeight})`}
                  </div>

                  <Rating
                    max={10}
                    name={rubricItem.rubricName}
                    value={rubricItem.value}
                    onChange={(event, newValue) => {
                      setIsRatingDecreaseError(false);
                      if (!newValue) return;
                      const newRating = [...rating];
                      const oldValue = fixedRating[index].value;
                      if (newValue < oldValue) {
                        setIsRatingDecreaseError(true);
                        return;
                      }
                      newRating[index].value = newValue;

                      setRating(newRating);
                    }}
                  />
                </div>
              ))}

              {isRatingDecreaseError && (
                <span className='text-red-700 text-sm'>
                  Ratings cannot be decreased!
                </span>
              )}

              <hr className='mt-4 mb-4' />

              <div className='text-gray-400 text-sm'>Plaigarism</div>
              <div className='flex items-center -mb-2 -ml-2'>
                <Radio
                  color='primary'
                  name='plaigarism'
                  value='self_written'
                  checked={plaigarism === 'self_written'}
                  onChange={handlePlaigarismCLick}
                />
                <span className='text-sm font-normal opacity-60'>
                  Self-written submission
                </span>
              </div>
              <div className='flex items-center -mb-2 -ml-2'>
                <Radio
                  color='primary'
                  name='plaigarism'
                  value='plagiarised'
                  checked={plaigarism === 'plagiarised'}
                  onChange={handlePlaigarismCLick}
                />
                <span className='text-sm font-normal opacity-60'>
                  Plagiarised submission
                </span>
              </div>

              <div className='text-sm text-gray-400 mt-4'>Feedback</div>
              <textarea
                disabled={true}
                rows='4'
                className='w-full border border-gray-300 focus:outline-none focus:border-blue-c1 focus:ring-1 focus:ring-blue-c1 rounded-lg p-2'
                value={feedbackText}
              />

              <div className='flex justify-center'>
                <button
                  className='w-max bg-red-700 py-2 px-10 my-4 font-medium text-white text-sm rounded focus:outline-none'
                  disabled={loading}
                  onClick={onSubmit}
                >
                  {loading ? (
                    <LoadingIcon className='animate-spin' />
                  ) : (
                    'Submit Feedback'
                  )}
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
